export const DivisionsLinks = [
  {
    name: 'Divisions Home',
    href: 'https://sheriff.utahcounty.gov/information/divisions',
  },
  {
    name: 'Administration',
    href: 'https://sheriff.utahcounty.gov/administration',
    nestedLinks: [
      {
        name: 'Firearms',
        href: 'https://sheriff.utahcounty.gov/administration/firearms',
      },
      {
        name: 'Police Conduct',
        href: 'https://sheriff.utahcounty.gov/administration/policeConduct',
      },
      {
        name: 'RAD Kids',
        href: 'https://sheriff.utahcounty.gov/administration/radkids',
      },
      {
        name: 'Records',
        href: 'https://sheriff.utahcounty.gov/administration/records',
      },
      {
        name: 'Training',
        href: 'https://sheriff.utahcounty.gov/administration/training',
      },
    ],
  },
  {
    name: 'Corrections',
    href: 'https://sheriff.utahcounty.gov/corrections',
    nestedLinks: [
      {
        name: 'Inmate Search',
        href: 'https://sheriff.utahcounty.gov/corrections/inmatesearch',
      },
      {
        name: 'Booking',
        href: 'https://sheriff.utahcounty.gov/corrections/booking',
      },
      {
        name: 'Work Diversion',
        href: 'https://sheriff.utahcounty.gov/corrections/workDiversion',
      },
      {
        name: 'Jail Industries',
        href: 'https://sheriff.utahcounty.gov/corrections/jailIndustries',
      },
      {
        name: 'GPS',
        href: 'https://sheriff.utahcounty.gov/corrections/gps',
      },
      {
        name: '24/7 Sobriety',
        href: 'https://sheriff.utahcounty.gov/corrections/sobriety',
      },
      {
        name: 'Orientation',
        href: 'https://sheriff.utahcounty.gov/corrections/orientation',
      },
    ],
  },
  {
    name: 'Enforcement',
    href: 'https://sheriff.utahcounty.gov/enforcement',
    nestedLinks: [
      {
        name: 'Patrol',
        href: 'https://sheriff.utahcounty.gov/enforcement/patrol',
      },
      {
        name: 'Investigations',
        href: 'https://sheriff.utahcounty.gov/enforcement/investigations',
      },
    ],
  },
  {
    name: 'Support Services',
    href: 'https://sheriff.utahcounty.gov/supportServices',
    nestedLinks: [
      {
        name: 'Emergency Management',
        href: 'https://sheriff.utahcounty.gov/supportServices/emergencyManagement',
      },
      {
        name: 'Emergency Services',
        href: 'https://sheriff.utahcounty.gov/supportServices/emergencyServices',
      },
      {
        name: 'Judicial - Courts',
        href: 'https://sheriff.utahcounty.gov/supportServices/judicial/courts',
      },
      {
        name: 'Judicial - Support',
        href: 'https://sheriff.utahcounty.gov/supportServices/judicial/support',
      },
    ],
  },
];

export const MediaLinks = [
  {
    name: 'Media Home',
    href: 'https://sheriff.utahcounty.gov/media',
  },
  {
    name: 'News & Press Releases',
    href: 'https://sheriff.utahcounty.gov/media/pressArchive',
  },
  {
    name: 'Most Wanted List',
    href: 'https://sheriff.utahcounty.gov/media/mostWanted',
  },
  {
    name: 'Missing Persons',
    href: 'https://sheriff.utahcounty.gov/media/missingPersons',
  },
  {
    name: 'Submit a Tip',
    href: 'https://sheriff.utahcounty.gov/media/tip',
  },
];

export const InformationLinks = [
  {
    name: 'Information Home',
    href: 'https://sheriff.utahcounty.gov/information',
  },
  {
    name: 'Accident Reports',
    href: 'https://sheriff.utahcounty.gov/information/accidentReport',
  },
  {
    name: 'Background/Records Checks',
    href: 'https://sheriff.utahcounty.gov/information/background',
  },
  {
    name: 'Compliments/Complaints',
    href: 'https://sheriff.utahcounty.gov/information/complaint_compliment',
  },
  {
    name: 'Divisions',
    href: 'https://sheriff.utahcounty.gov/information/divisions',
  },
  {
    name: 'FAQS',
    href: 'https://sheriff.utahcounty.gov/information/faqs',
  },
  {
    name: 'Forms',
    href: 'https://sheriff.utahcounty.gov/information/forms',
  },
  {
    name: 'Recovered Property',
    href: 'https://sheriff.utahcounty.gov/information/recoveredProperty',
  },
  {
    name: 'Thistle Gun Range',
    href: 'https://sheriff.utahcounty.gov/information/firearms',
  },
  {
    name: 'Off Duty',
    href: 'https://sheriff.utahcounty.gov/information/offDuty',
  },
];
